import { render } from "./SortList.vue?vue&type=template&id=3decb188"
import script from "./SortList.vue?vue&type=script&lang=js"
export * from "./SortList.vue?vue&type=script&lang=js"

import "./SortList.vue?vue&type=style&index=0&id=3decb188&lang=scss"

import exportComponent from "D:\\work\\粤智康医药网\\guanwang\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__